import './QuantityInput.css';

export function QuantityInput(props: {
   quantity: number;
   setQuantity: (quantity: number) => void;
   disabled?: boolean;
   max?: number;
   smaller?: boolean;
   onChange?: (newQuantity: number) => void;
   changeAmount?: number;
}) {
   const { quantity, setQuantity, disabled, max, smaller, onChange, changeAmount = 1 } = props;

   return (
      <div className={`quantity-input-container  ${smaller ? 'smaller' : ''}`}>
         <button
            onClick={() => {
               const newQuantity = (quantity || 1) - changeAmount;
               setQuantity(newQuantity);
               onChange && onChange(newQuantity);
            }}
            disabled={disabled || quantity === 0}
            className="quantity-input-button">
            <img
               src="/assets/icons/minus-icon.svg"
               width={25}
            />
         </button>
         <input
            type="number"
            value={isNaN(quantity) ? '' : quantity}
            disabled={disabled}
            onChange={(e) => {
               const newQuantity = parseInt(e.target.value);
               setQuantity(newQuantity);
               onChange && onChange(newQuantity);
            }}
            className="quantity-input flex-1"
            style={{ width: `${quantity.toString().length}ch` }}
         />
         <button
            onClick={() => {
               const newQuantity = (quantity || 0) + changeAmount;
               setQuantity(newQuantity);
               onChange && onChange(newQuantity);
            }}
            disabled={disabled || (max !== undefined && quantity === max)}
            className="quantity-input-button">
            <img
               src="/assets/icons/plus-icon.svg"
               width={25}
            />
         </button>
      </div>
   );
}
